import { render, staticRenderFns } from "./BookiesLogos.vue?vue&type=template&id=4f642fb8&scoped=true&"
import script from "./BookiesLogos.vue?vue&type=script&lang=js&"
export * from "./BookiesLogos.vue?vue&type=script&lang=js&"
import style0 from "./BookiesLogos.vue?vue&type=style&index=0&id=4f642fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f642fb8",
  null
  
)

export default component.exports